function getDefaultState() {
    return {
      isLoading: false,
    };
  }
  
  const state = getDefaultState();
  
  const getters = {
    loading(state) {
      return state.isLoading;
    }
  };
  
  const mutations = {
    habilitarLoading(state, status) {
      state.isLoading = status;
    },
  };
  
  const actions = {
    habilitarLoading: ({ commit }, status) => {
      commit('habilitarLoading', status);
    },
  };
  
  export default { namespaced: true, state, mutations, getters, actions };
  